module.exports = __webpack_public_path__ + "img/益视说明书_20.5579360b.png";